import { ISignupUserApiQueryProps, ISignupUserBody } from '../api/signup';
import {
    CREATOR_ONBOARDING_PATH,
    CREATOR_ONBOARDING_URL_BLACKLIST,
    CREATOR_ONBOARDING_URL_WHITELIST,
    ONBOARDING_REDIRECT_URL_BLACKLIST,
} from '../constants';
import { IAllContextsProps, ISignupFormProps } from '../constants/interfaces';
import { IConfigContextProps } from '../contexts/ConfigContext';

export const shouldRedirectToOnboarding = ({
    redirectUrl,
}: {
    redirectUrl?: string;
}) => {
    const referrer = decodeURIComponent(redirectUrl ?? '');

    return !ONBOARDING_REDIRECT_URL_BLACKLIST.find((blacklistedPath) =>
        referrer.includes(blacklistedPath),
    );
};
export const shouldRedirectToCreatorOnboarding = ({
    redirectUrl,
}: {
    redirectUrl?: string;
}) => {
    const referrer = decodeURIComponent(redirectUrl ?? '');
    const isInWhiteList =
        CREATOR_ONBOARDING_URL_WHITELIST.find((whitelistedPath) =>
            referrer.startsWith(whitelistedPath),
        ) ?? false;
    const isNotInBlackList =
        !CREATOR_ONBOARDING_URL_BLACKLIST.find((blacklistedPath) =>
            referrer.startsWith(blacklistedPath),
        ) ?? false;

    return isInWhiteList && isNotInBlackList;
};

export const getSignupApiData = ({
    data,
    verificationCode,
}: {
    data: ISignupUserApiQueryProps;
    verificationCode?: string;
}) => {
    const body: ISignupUserBody = {
        user: {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
        },
        password: data.password,
        auto_subscribe: false,
    };

    verificationCode ? (body['verification_code'] = verificationCode) : null;

    return body;
};
export const getSignupFormData = ({
    formData,
    contexts,
}: {
    formData: ISignupFormProps;
    contexts: IAllContextsProps;
}) => {
    const {
        firstName,
        lastName,
        password,
        captcha: recaptchaResponse,
        email: formEmail,
    } = formData;

    const email = contexts.userContext?.state.lookup.existentAccount;
    const tosSocialAccepted = contexts.userContext?.state.tosSocialAccepted;
    const { forward, pckg } = contexts.configContext ?? {};
    // const {
    //     userTypeParams
    // } = getState();

    const _email = formEmail || email;

    const signupData = {
        password,
        firstName,
        lastName,
        recaptchaResponse,
        email: _email,
        forward,
        // ...userTypeParams,
        pckg,
    } as any;

    // Only add this extra parameter when user accept ToS by Popup in new design.
    if (tosSocialAccepted) {
        signupData.acceptedTosByPopup = 1;
    }

    return signupData;
};

export const getNewUserRedirectUrl = ({
    redirectUrl,
    configContext,
}: {
    redirectUrl?: string;
    configContext?: IConfigContextProps;
}) => {
    let _redirectUrl = redirectUrl ?? configContext?.referrer ?? '';

    if (!_redirectUrl && global.window && window.localStorage) {
        _redirectUrl = localStorage.getItem('referrer') ?? '';
        // We need to remove the referrer from the local storage, so it won't cause issues on future logins.
        localStorage.removeItem('referrer');
    }

    if (shouldRedirectToCreatorOnboarding({ redirectUrl: _redirectUrl })) {
        return CREATOR_ONBOARDING_PATH;
    }

    if (shouldRedirectToOnboarding({ redirectUrl: _redirectUrl })) {
        return `/u/interests/?onboarding_referrer=${_redirectUrl}`;
    }

    return _redirectUrl;
};
